export default __webpack_public_path__ + "static/media/CGV.6902dde3.jpg";